<template>
    <div class="w-[450px] flex flex-col gap-[16px]">
      <h1 class="font-minion text-[32px] leading-[38.4px] font-semibold text-[#121212]">
        {{ title }}
      </h1>
      <p class="text-[16px] leading-[24px] font-semibold text-[#666666]" style="font-family: 'Open Sans'; font-weight: 600;">
        {{ subtitle }}
      </p>
    </div>
  </template>
  
  <script setup>
  defineProps({
    title: String,
    subtitle: String
  });
  </script>
  